module.exports = __webpack_public_path__ + "assets/img/hyqj-title-two.95db81d4.png";